import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme-v2.css';
import './theme-demo-stats.css';
import App from './App';
import { TenantProvider } from './context/TenantContext';
import reportWebVitals from './reportWebVitals';
import { applyRevampTheme } from './utils/revampTheme';

// The purple + white theme: every rule in theme-v2.css needs this class, so
// with the flag off the stylesheet matches nothing. Set before the first paint
// so a patient-facing page never shows it; AppShell keeps it right on navigation.
applyRevampTheme(window.location.pathname);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TenantProvider>
      <App />
    </TenantProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
